import React from "react";
import "./Input.css";
import { clsx } from "../../utils/clsx";
import Textarea from "../Textarea/Textarea";
import { useComponentDefaults } from "../../Provider";

const Input = React.forwardRef(function Input(props, ref) {
  const merged = useComponentDefaults(
    'Input',
    props,
    {
      variant: 'default',
      shape: 'default',
      color: 'default',
    },
    { demoteThemeKeys: ['color'] }
  );
  // Do not leak design-system-only props to the DOM element
  const {
    className,
    variant = 'default',
    shape = 'default',
    color = 'default',
    size, // DS size token, not the HTML size attribute
    align, // DS alignment token
    slotProps, // consumed by useComponentDefaults
    value,
    defaultValue,
    ...rest
  } = merged;

  const inputProps = { ...rest };

  if (value !== undefined) {
    inputProps.value = value == null ? '' : value;
  }

  if (defaultValue !== undefined) {
    inputProps.defaultValue = defaultValue == null ? '' : defaultValue;
  }
  return (
    <input
      ref={ref}
      className={clsx(
        "ds-input",
        `ds-input--variant-${variant}`,
        `ds-input--shape-${shape}`,
        color !== "default" && `ds-input--color-${color}`,
        "ds-focusable",
        className
      )}
      {...inputProps}
    />
  );
});

Input.displayName = 'DesignSystemInput';

Input.Password = React.forwardRef(function PasswordInput(props, ref) {
  return <Input ref={ref} type="password" {...props} />;
});
Input.Password.displayName = 'DesignSystemInputPassword';

// Backwards-compat: support Input.TextArea usage
Input.TextArea = React.forwardRef(function DesignSystemInputTextArea(props, ref) {
  return <Textarea ref={ref} {...props} />;
});
Input.TextArea.displayName = 'DesignSystemInputTextArea';

export default Input;
